import { render, staticRenderFns } from "./private-sales-kata.vue?vue&type=template&id=58526f3c&"
import script from "./private-sales-kata.vue?vue&type=script&lang=js&"
export * from "./private-sales-kata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports